import { useState, useEffect } from 'react';

export const usePreloadImage = (src?: string) => {
	const [sourceLoaded, setSourceLoaded] = useState<string | undefined>();

	useEffect(() => {
		if (!src) return;
		const img = new Image();
		img.src = src;
		img.onload = () => setSourceLoaded(src);
	}, [src]);

	return sourceLoaded;
}
